export default __webpack_public_path__ + "static/logo-sin-nl-8810d8dcbbdb230c4e8b4b96300e687a.png";